import type { UserLoginRo } from '../services/api.generated';

export const AUTH_USER_STORAGE_KEY = 'user';
export const AUTH_TOKEN_STORAGE_KEY = 'token';

/** A saved user the auth slice can use (isAdmin reads roleNames). */
export const isStoredUser = (value: unknown): value is UserLoginRo =>
  !!value &&
  typeof value === 'object' &&
  Array.isArray((value as UserLoginRo).roleNames) &&
  (value as UserLoginRo).roleNames.every((role) => typeof role === 'string');
